import env from '../env';
import getDomain from './get-domain';
export const getHostname = url => {
  const {
    hostname
  } = new URL(url, global.location.href);
  return hostname;
};
export const isAllowedHostname = (url, {
  allowedHostnames,
  allowSubdomains = true
} = {}) => {
  const parsed = decodeURIComponent(url);
  // will match any URL that starts with an external scheme (eg. `mailto:`, `https:`, `ftp:`, `git+ssh:`, `//`)
  if (/^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(parsed)) {
    const defaultHostnames = (env.REACT_APP_ALLOWED_EXTERNAL_HOSTNAME || '').replace(/\s/g, '').split(',');
    const hostnames = (allowedHostnames || defaultHostnames).concat(global.location.hostname).filter(Boolean);
    const targetHostname = getHostname(parsed);
    const haystack = allowSubdomains ? hostnames.map(getDomain) : hostnames;
    const needle = allowSubdomains ? getDomain(targetHostname) : targetHostname;
    return haystack.includes(needle);
  }

  // relative URLs
  return true;
};
export const joinPaths = (...paths) => paths.reduce((accumulator, currentValue) => {
  const val = currentValue != null ? String(currentValue).trim() : currentValue;
  if (!val) return accumulator;
  const ends = accumulator.endsWith('/');
  const starts = val.startsWith('/');
  const junction = starts || ends || accumulator === '' ? '' : '/';
  const nextPath = starts && ends ? val.slice(1) : val;
  return `${accumulator}${junction}${nextPath}`;
}, '');
export const isAbsoluteUrl = url => {
  // RFC 3986 scheme + protocol-relative URLs
  // will match any URL that starts with an external scheme (eg. `mailto:`, `https:`, `ftp:`, `git+ssh:`, `//`)
  return /^(?:[a-zA-Z][a-zA-Z0-9+.-]*:|\/\/)/.test(url);
};

// Adds query parameters to a URL that may already have some
export const buildUrlWithParams = (url, params) => {
  if (!url || !params || typeof params !== 'object' || Object.keys(params).length === 0) {
    return url;
  }
  const isAbsolute = isAbsoluteUrl(url);
  const base = window.location.origin + window.location.pathname;
  let urlObj;
  try {
    urlObj = new URL(url, isAbsolute ? undefined : base);
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // Handle arrays by adding multiple entries with the same key
        value.forEach(item => {
          urlObj.searchParams.append(key, String(item));
        });
      } else if (value !== null && value !== undefined) {
        urlObj.searchParams.set(key, String(value));
      }
    });

    // For relative URLs, return only pathname + search + hash (strip base)
    if (!isAbsolute) {
      return urlObj.pathname + urlObj.search + urlObj.hash;
    }
    return urlObj.toString();
  } catch (error) {
    return url;
  }
};
//# sourceMappingURL=url.js.map